<template>
  <div class="d-flex align-center ga-3 contact-actions">
    <!-- Show -->
    <div class="show cursor-pointer">
      <svg @click="$router.push({ name: 'ShowContact', params: { id: item.id } })" width="16" height="16"
        viewBox="0 0 16 16" fill="none">
        <path
          d="M0.666504 8C0.666504 8 3.33317 2.66675 7.99984 2.66675C12.6665 2.66675 15.3332 8 15.3332 8C15.3332 8 12.6665 13.3334 7.99984 13.3334C3.33317 13.3334 0.666504 8 0.666504 8Z"
          stroke="#666666" stroke-width="1.2" />
        <path
          d="M7.99984 10C9.10441 10 9.99984 9.10457 9.99984 8C9.99984 6.89543 9.10441 6 7.99984 6C6.89527 6 5.99984 6.89543 5.99984 8C5.99984 9.10457 6.89527 10 7.99984 10Z"
          stroke="#666666" stroke-width="1.2" />
      </svg>
    </div>

    <!-- Edit -->
    <div class="edit cursor-pointer" :disabled="!$permissionsFor('leads-managment').update"
      :class="{ 'read-only': !$permissionsFor('leads-managment').update }">
      <svg @click.stop.prevent="openDialog(item.id)" width="16" height="16" viewBox="0 0 16 16" fill="none"
        xmlns="http://www.w3.org/2000/svg" class="hoverd">
        <g clip-path="url(#clip0_2868_26728)">
          <path
            d="M11.3335 2.00004C11.5086 1.82494 11.7165 1.68605 11.9452 1.59129C12.174 1.49653 12.4192 1.44775 12.6668 1.44775C12.9145 1.44775 13.1596 1.49653 13.3884 1.59129C13.6172 1.68605 13.8251 1.82494 14.0002 2.00004C14.1753 2.17513 14.3142 2.383 14.4089 2.61178C14.5037 2.84055 14.5524 3.08575 14.5524 3.33337C14.5524 3.58099 14.5037 3.82619 14.4089 4.05497C14.3142 4.28374 14.1753 4.49161 14.0002 4.66671L5.00016 13.6667L1.3335 14.6667L2.3335 11L11.3335 2.00004Z"
            stroke="#666666" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
        </g>
        <defs>
          <clipPath id="clip0_2868_26728">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div>
    <!-- Delete -->
    <div class="delete cursor-pointer" :disabled="!$permissionsFor('leads-managment').delete"
      :class="{ 'read-only': !$permissionsFor('leads-managment').delete }">
      <svg @click.stop.prevent="deleteClickPermission()" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path d="M14.95 2.105H1.05" stroke="#CC0000" stroke-width="1.2" />
        <path d="M5.66 1.618V2.105M10.34 1.618V2.105" stroke="#CC0000" stroke-width="1.2" />
        <path
          d="M2.65 3.042V13.149C2.65 13.9049 3.57 14.86 4.56 14.86H11.44C12.43 14.86 13.35 13.9049 13.35 13.149V3.042"
          stroke="#CC0000" stroke-width="1.2" />
        <path d="M6.53 5.037V12.335M9.47 5.037V12.335" stroke="#CC0000" stroke-width="1.2" />
      </svg>
    </div>
  </div>

  <GeneralEdit v-model:dialog="dialog" :recordId="selectedId" :apiEndpoint="apiUrl" :fields="fields"
    :masterData="masterData" title="Edit Contact" @submitted="afterSave" />
  <v-dialog v-model="deleteDialog" width="auto">
    <v-card max-width="550">
      <template v-slot:text>
        <div>
          <div class="d-flex justify-space-between align-center mb-8">
            <svg width="56" height="57" viewBox="0 0 56 57" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="4" y="4.5" width="48" height="48" rx="24" fill="#FEE4E2" />
              <rect x="4" y="4.5" width="48" height="48" rx="24" stroke="#FEF3F2" stroke-width="8" />
              <path
                d="M32 22.5V21.7C32 20.5799 32 20.0198 31.782 19.592C31.5903 19.2157 31.2843 18.9097 30.908 18.718C30.4802 18.5 29.9201 18.5 28.8 18.5H27.2C26.0799 18.5 25.5198 18.5 25.092 18.718C24.7157 18.9097 24.4097 19.2157 24.218 19.592C24 20.0198 24 20.5799 24 21.7V22.5M26 28V33M30 28V33M19 22.5H37M35 22.5V33.7C35 35.3802 35 36.2202 34.673 36.862C34.3854 37.4265 33.9265 37.8854 33.362 38.173C32.7202 38.5 31.8802 38.5 30.2 38.5H25.8C24.1198 38.5 23.2798 38.5 22.638 38.173C22.0735 37.8854 21.6146 37.4265 21.327 36.862C21 36.2202 21 35.3802 21 33.7V22.5"
                stroke="#CC0000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            <svg @click="deleteDialog = false" width="24" height="24" viewBox="0 0 24 24" fill="none"
              xmlns="http://www.w3.org/2000/svg" class="cursor-pointer hoverd">
              <path d="M18 6L6 18M6 6L18 18" stroke="#717680" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
          </div>
          <div class="delete-dialog-body">
            <div class="main mb-2">
              Are you sure you want to delete this item
            </div>
            <div class="sub">
              If you deleted this item you won’t be able to restore it again
            </div>
          </div>
        </div>
      </template>
      <template v-slot:actions>
        <div class="pa-4 d-flex align-center ga-3">
          <v-btn class="cancel-btn" text="Cancel" @click="deleteDialog = false"></v-btn>
          <v-btn class="delete-btn text-capitalize" color="white" text="Delete" @click="deleteContact"></v-btn>
        </div>
      </template>
    </v-card>
  </v-dialog>
</template>

<script>
import apiClient from "@/core/buildRequest";
import { useContactsStore } from "@/store/crm/useContactsStore";
import { useGeneralStore } from "@/store/General";
import GeneralEdit from "@/components/crm/assets/forms/edit/GeneralEdit.vue";
import { loginForm } from "@/store/logIn";

export default {
  name: "ContactActions",
  props: ["item"],
  components: { GeneralEdit },
  data() {
    return {
      dialog: false,
      deleteDialog: false,
      selectedId: null,
      apiUrl: "/leads-managment/contacts",
      masterData: {
        countries: [],
        cities: [],
        job_titles: [],
        accounts: [],
      },
      fields: [
        {
          model: "first_name",
          label: "First Name",
          type: "text",
          required: true,
        },
        {
          model: "last_name",
          label: "Last Name",
          type: "text",
          required: true,
        },
        { model: "phone", label: "Phone", type: "text", required: true },
        { model: "email", label: "Email", type: "text", required: true },
        {
          model: "country_id",
          label: "Country",
          type: "select",
          required: true,
          lazy: true,
          remoteEndpoint: "/leads-managment/countries",
          itemValue: "id",
          itemTitle: "name",
          map: (d) => d.country?.id || null,
        },
        {
          model: "city_id",
          label: "City",
          type: "select",
          required: true,
          lazy: true,
          dependsOn: "country_id",
          getRemoteEndpoint: (formData) => {
            if (!formData.country_id) return null;
            return `/leads-managment/cities/${formData.country_id}`;
          },
          itemValue: "id",
          itemTitle: "name",
          map: (d) => d.city?.id || null,
        },
        {
          model: "job_title_id",
          label: "Job Title",
          type: "select",
          required: true,
          lazy: true,
          remoteEndpoint: "/leads-managment/job-titles",
          itemValue: "id",
          itemTitle: "name",
          map: (d) => d.job_title?.id || null,
        },
        {
          model: "potentiality",
          label: "Potentiality",
          type: "select",
          required: true,
          items: ["A", "B", "C", "VIP"],
        },
        { model: "notes", label: "Notes", type: "text" },
        {
          model: "account_id",
          label: "Account",
          type: "select",
          required: true,
          lazy: true,
          remoteEndpoint: "/leads-managment/select-accounts",
          itemValue: "id",
          itemTitle: "name",
          map: (d) => d.account?.[0]?.id || null,
        },
      ],
      loginStore: loginForm(),
    };
  },
  methods: {
    openDialog(id) {
      this.selectedId = id;
      this.dialog = true;
    },
    afterSave() {
      const contact_store = useContactsStore();
      const general_store = useGeneralStore();
      contact_store.getAllContacts();
      general_store.showSnackbar("Contact updated successfully", "#237276");
    },
    async deleteContact() {
      const contact_store = useContactsStore();
      const general_store = useGeneralStore();
      try {
        general_store.ShowLoading();
        await apiClient.post(
          `/leads-managment/delete/contacts/${this.item.id}`
        );
        contact_store?.deleteContact(this.item);
        await contact_store?.getAllContacts();
        general_store.showSnackbar("Contact deleted successfully", "#237276");
      } catch (error) {
        const msg = error.response?.data?.msg || "Failed to delete contact";
        general_store.showSnackbar(msg, "error");
        console.error(error);
      } finally {
        this.deleteDialog = false;
        general_store.HideLoading();
      }
    },
    handleClickPermission() {
      if (!this.hasWritePermission) return;
      this.dialog = true;
    },
    deleteClickPermission() {
      if (!this.hasWritePermission) return;
      this.deleteDialog = true;
    },

    HavePermission(p) {
      return this.loginStore?.permissions?.includes(p) || false;
    },
  },
  computed: {
    hasWritePermission() {
      return this.loginStore?.permissions?.some((p) =>
        [
          "leads-managment.update",
          "leads-managment.create",
          "leads-managment.delete",
        ].includes(p)
      );
    },
  },
};
</script>

<style scoped>
.text-grey {
  color: #6a6a6a;
}

.delete-dialog-body .main {
  font-size: 20px;
  font-weight: 600;
  line-height: 24.2px;
  color: #222;
}

.disabled-module {
  pointer-events: none;
  opacity: 0.5;
}
</style>
